import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { LoginRegister, Profile, Company, Connections } from './pages/AllPages'; 
import { AuthProvider } from './contexts/AuthContext';
import Header from './components/Header';
import NotFound from './components/NotFound';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <ScrollToTop />
      <Header />
      <Routes>

        <Route path='/' element={<LoginRegister />} />
        <Route path='/login' element={<LoginRegister />} />
        <Route path='/forgot-password' element={<ForgotPassword />} />
        <Route path='/reset-password/:uidb64/:token' element={<ResetPassword />} />
        
        <Route 
          path='/perfil' 
          element={ <ProtectedRoute><Profile /></ProtectedRoute> } 
        />
        <Route 
          path='/empresa' 
          element={ <ProtectedRoute><Company /></ProtectedRoute> } 
        />
        
        <Route 
          path='/conexiones' 
          element={ <ProtectedRoute><Connections/></ProtectedRoute> } 
        />

        <Route path='*' element={<NotFound />} />
      </Routes>
      <Footer />
      <div id="popup-root"></div>
    </AuthProvider>
  );
}

export default App;